export default __webpack_public_path__ + "static/media/ic_color_whatsapp.03694a84.svg";